module.exports = __webpack_public_path__ + "img/client-3.eb79e07f.png";